import React from 'react';
import FrameHeader from './FrameHeader';

interface FrameProps {
  shouldShowFrameHeader?: boolean;
  shouldShowFrameSideBar?: boolean;
}

const Frame = ({ shouldShowFrameHeader = true }: FrameProps) => {
  return <>{shouldShowFrameHeader && <FrameHeader />}</>;
};

export default Frame;
